/**
 * Not Logged In page.
 * Shown when a user tries to access an authenticated route
 * without a valid session.
 *
 * @module pages/notLoggedIn
 */

import React              from 'react';
import Layout             from '../components/Layout';
import UnderConstruction  from '../components/UnderConstruction';
import { useI18n }        from '../dataProviders/I18nProvider';

/**
 * Renders the Not Logged In placeholder page.
 *
 * @returns {React.ReactElement}
 */
export default function NotLoggedIn() {
  const { t } = useI18n();

  return (
    <Layout title={t('page.notLoggedIn')}>
      <UnderConstruction />
    </Layout>
  );
}
